import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">The Bucket</div>
                                            <p>The Bucket appears open to feedback but will not pick up on
                                                messages, either positive or negative, unless they are given
                                                loudly and clearly. </p>
                                            <p>This individual has a tendency to minimise negative messages so
                                                it is important that you check and recheck that your message has
                                                been heard. You may need to give the same message a number of
                                                times and in different ways. </p>
                                            <p><span className="subtiltereg">Risk –</span> subtle feedback will
                                                not be picked up on.</p>

                                            <div className="border_subtitle">The Funnel</div>
                                            <p>The Funnel appears to be accepting of feedback and is, to a
                                                certain extent, but is also good at giving the impression of
                                                listening without truly doing so.</p>
                                            <p>In a feedback session you will need to frequently ask this
                                                individual to reflect back what they have heard, e.g. ‘what do
                                                you see the most significant points that we have discussed
                                                being?’ At the end, ask them to take away specific actions. In
                                                the longer term, you will need to give practical support and
                                                encouragement to ensure that this individual takes the action
                                                that they willingly agreed to take. </p>
                                            <p><span className="subtiltereg">Risk –</span> the funnel will look
                                                willing but do nothing.</p>

                                            <div className="border_subtitle">The Teacup</div>
                                            <p>The Teacup is highly sensitive to criticism and will be concerned
                                                that negative feedback is linked to personal failure.</p>
                                            <p>You will need to give developmental messages using careful
                                                diplomatic language and cushion them with appreciation of other
                                                strengths and positive messages. This individual needs to feel
                                                safe, appreciated and valued before they will be able to learn
                                                and grow from developmental feedback. Don’t overreact to a
                                                teacup’s tears as they are a part of this individual’s self
                                                expression and are usually useful – although be wary if they are
                                                used to deflect the feedback! </p>
                                            <p><span className="subtiltereg">Risk –</span> they may be crushed
                                                and overwhelmed.</p>

                                            <div className="border_subtitle">The Bullet Proof Vest</div>
                                            <p>The Bullet Proof Vest finds it difficult to see feedback as
                                                anything other than ammunition. When you wish to give them
                                                feedback they will feel under attack, be defensive and ready to
                                                challenge what you say.</p>
                                            <p>You will need to address this defensiveness before giving the
                                                feedback and this may mean letting the individual know that they
                                                seem defensive, asking them why and persuading them to to
                                                explore this with you. You can make it easier for them by
                                                letting them know that it is okay for them to challenge, as long
                                                as they’re willing to be open-minded.</p>
                                            <p><span className="subtiltereg">Risk –</span> they won’t listen and
                                                the relationship will be damaged.</p>

                                            <div className="border_subtitle">The Stagnant Pond</div>
                                            <p>The Stagnant Pond has heard it all before. They know what their
                                                strengths, weaknesses, development areas, favourite competencies
                                                and skills are. The trouble with this individual is that they
                                                see no reason why they should change themselves – improve their
                                                weaknesses or build on their strengths.</p>
                                            <p>As this individual is already fairly self aware and can predict
                                                the developmental feedback that you are going to give them, you
                                                will need to explore why they have continued receiving the same
                                                messages. You may motivate this individual by helping them see
                                                how it is within their control to make changes. An appreciative
                                                approach will help them visualise their future career and focus
                                                on developing in areas that are critical to success.</p>
                                            <p><span className="subtiltereg">Risk –</span> a lack of motivation
                                                to act will prevent success.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}